export enum AccountConfigType {

    Mobile = "mobile",
    Desktop = "desktop"
}
